export default __webpack_public_path__ + "static/media/618.dc161993.jpg";